import { CommonButton } from 'components/Button'
import styled from 'styled-components'
import theme from 'theme_'

export const FullscreenModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${theme.spacing.s} ${theme.spacing.base};
  background-color: ${theme.colors.white};
  box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.05);

  @media ${theme.devices.tablet} {
    padding: ${theme.spacing.sm} ${theme.spacing.md};
  }
`

export const FullscreenModalContent = styled.div`
  padding: ${theme.spacing.base};
  margin-bottom: ${theme.spacing.xlarge};

  @media ${theme.devices.tablet} {
    padding: ${theme.spacing.lg};
  }
`

export const FullscreenModalFooter = styled.div`
  display: flex;
  position: fixed;
  z-index: ${theme.zIndex.fixedHeader};
  bottom: 0;
  left: 0;
  right: 0;
  padding: ${theme.spacing.base};
  background-color: ${theme.colors.white};
  gap: ${theme.spacing.base};
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.1);

  @media ${theme.devices.tablet} {
    padding: ${theme.spacing.base} ${theme.spacing.lg};
    justify-content: flex-end;
  }
`

export const FullscreenModalFooterButton = styled(CommonButton)`
  width: 100%;

  @media ${theme.devices.tablet} {
    width: 160px;
  }
`
